import { Action, createReducer, on } from '@ngrx/store';
import { SystemEntity } from '@wdx/clmi/clmi-swagger-gen';
import * as DynamicPagesActions from './dynamic-pages.actions';

export const DYNAMIC_PAGES_FEATURE_KEY = 'dynamicPages';

export enum DynamicPagesEventTypes {
    Reload,
}

export interface DynamicPagesEvent {
    eventType: DynamicPagesEventTypes;
    timestamp: number;
    entityType: SystemEntity;
}

export interface State {
    events: DynamicPagesEvent[];
}

export interface DynamicPagesPartialState {
    readonly [DYNAMIC_PAGES_FEATURE_KEY]: State;
}

export const initialState: State = {
    events: [],
};

const reducer = createReducer(
    initialState,
    on(DynamicPagesActions.newEvent, (state, { eventType, entityType }) => ({
        ...state,
        events: [
            ...state.events,
            { eventType, entityType, timestamp: Date.now() },
        ],
    })),
);

export function dynamicPagesReducer(state: State | undefined, action: Action) {
    return reducer(state, action);
}
